export default __webpack_public_path__ + "static/media/space_object_02.ac7dec90.svg";